import { Artist } from './types';

export const _getArtistApiUrl = (eventId: string) =>
    `/attendee/event-listing/v1/events/${eventId}/artists`;

export const getArtistData = async (eventId: string, artistList: Artist[]) => {
    const apiUrl = _getArtistApiUrl(eventId);
    const response: Response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    const responseData = await response.json();
    if (!response.ok) {
        throw new Error('Failed to fetch artist data');
    }
    if (responseData.artists.length === 0) {
        throw new Error('No artists found');
    }
    //transform the data to match the expected format
    const transformedArtists = responseData.artists.map(
        (artist: any, index: number) => ({
            id: artist.artistId,
            name: artist.name,
            tagline: artistList[index].tagline,
            imageUrl: artist.images[0]?.thumbnailUrl,
            fullSizeImageUrl: artist.images[0]?.fullSizeUrl,
            role: artist.performerRole,
            socialMedia: artist.socialMediaLinks,
            bio: artist.biography,
        }),
    );
    return transformedArtists;
};
